'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CmsPage = exports.mapDispatchToProps = exports.mapStateToProps = undefined;

var _reactRedux = require('react-redux');

var _Banners = require('features/Banners/Banners.reducer');

var _page = require('redux/modules/page');

var _bound = require('redux/saga/entities/bound');

var _verify = require('helpers/verify');

var _CmsPage = require('components/CmsPage/CmsPage');

var _cmsDataToModuleArray = require('components/CmsPage/cmsDataToModuleArray');

var _Sagas = require('decorators/Sagas');

var _cmsPage = require('./cms-page.saga');

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state, props) {
  var pathForCms = _bound.cms.defaultKey(null, props.location.pathname);
  var cmsData = _bound.cms.data(state, pathForCms) || {};
  return {
    cmsData: cmsData,
    hideFooter: !!cmsData.hideFooter,
    hideHeader: !!cmsData.hideHeader,
    location: props.location,
    modules: (0, _verify.isEmpty)(cmsData) ? [] : (0, _cmsDataToModuleArray.cmsDataToModuleArray)(state, cmsData),
    path: pathForCms
  };
};

var mapDispatchToProps = exports.mapDispatchToProps = {
  clearBanners: _Banners.clearAllBanners,
  loadCmsPage: _cmsPage.loadCmsPage,
  useReducedFooter: _page.useReducedFooter,
  useReducedNavigation: _page.useReducedNavigation
};

var sagaDecorator = (0, _Sagas.withSagas)({
  watch: _cmsPage.watchCmsPageSagas
});

var reduxDecorator = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps);

var CmsPage = exports.CmsPage = reduxDecorator(sagaDecorator(_CmsPage.CmsPage));